export default __webpack_public_path__ + "static/card1-desktop-ceda73da382a5728c9cc4a7ad1d2dfa1.png";